<template>
    <div></div>
    <!--
    <div class="hideonmobile">
        <div class="div-block-2">
            <div class="div-block-3">
                <div class="status">
                    <div class="status small"></div>
                </div>
                <p class="text-small no-padding opaque">{{$t('demandScale_network_status')}}: <strong class="white">{{impressionsLast24hr}}</strong> {{$t('ads_served_and')}} <strong class="white">{{installsLast24hr}}</strong> {{$t('installs_in_the_last')}} <strong class="white">{{$t('24h')}}</strong></p>
            </div>
        </div>
    </div>
    -->
</template>

<style>
    .div-block-2 {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        padding: 12px 40px;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -webkit-flex-direction: row;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        background-color: #36000a;
    }

    .div-block-3 {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .status {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        width: 8px;
        height: 8px;
        margin-right: 10px;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        border-radius: 20px;
        background-color: #1effbc;
        box-shadow: 0 0 8px 0 #1effbc;
    }

    .status.small {
        width: 4px;
        height: 4px;
        margin-right: 0;
        background-color: #df9;
    }

    .text-small {
        font-size: 14px;
        font-weight: 400;
        font-family: "Arial", sans-serif;
        letter-spacing: 0.35px;
    }

    .text-small.no-padding {
        margin-bottom: 0;
    }

    .text-small.no-padding.opaque {
        color: #aa9397;
        line-height: 16px;
    }

    .white {
        color: #fff;
    }

    @media (max-width: 991px) {
        .text-small {
            font-size: 13px;
        }
    }
    @media (max-width: 479px) {
        .hideonmobile {
            display: none;
        }
        .div-block-2 {
            display: none;
        }
    }
</style>

<script>
    import axios from 'axios'

    const defaultImpressionsLast24hr = '317M';
    const defaultInstallsLast24hr = '121k';

    const networkStatus = {
        impressionsLast24hr: null,
        installsLast24hr: null
    };

    export default {
        data () {
            return networkStatus;
        }
    }

    axios.get('https://ds-api.prod.sift.co/stats', { crossdomain: true })
            .then(response => {
                if (!response.data || !response.data.impressions_last24hr || !response.data.installs_last24hr) {
                    networkStatus.impressionsLast24hr = defaultImpressionsLast24hr;
                    networkStatus.installsLast24hr = defaultInstallsLast24hr;
                } else {
                    networkStatus.impressionsLast24hr = Math.floor(response.data.impressions_last24hr / 1000000) + 'M';
                    networkStatus.installsLast24hr = Math.floor(response.data.installs_last24hr / 1000) + 'k';
                }
            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
                networkStatus.impressionsLast24hr = defaultImpressionsLast24hr;
                networkStatus.installsLast24hr = defaultInstallsLast24hr;
            });
</script>
